'use client'

import { Button } from '@/components/Button/Button';
import useCartStore from '@/store/useCartStore';
import { FilteredTicketType } from '@/types/AdminPanelType';
import { groupCartTicketsBySection } from '@/utils/CartUtils';

import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { CartListItem } from '../CartListItem/CartListItem';
import styles from './CartList.module.scss';

type CartListProps = {
  ticketSections: FilteredTicketType[]
}

export default function CartList({ticketSections} : CartListProps) {



  const cart = useCartStore(state => state.cart);
  const cartLoading = useCartStore(state => state.cartLoading);
  const getCart = useCartStore(state => state.getCart);
  const cartMetaTotalCount = useCartStore(state => state.cartMetaTotalCount);

  const router = useRouter();

  const [loading, setLoading] = useState<boolean>(cartLoading)

  const nextStepButton = cartMetaTotalCount > 0 ? <Button className={styles.btn} disabled={loading} loading={loading} onClick={() => { router.push('/cart/checkout'), setLoading(true) }}>Checkout</Button> : null

  const ticketList = cart.data.tickets ? groupCartTicketsBySection(cart.data.tickets, ticketSections) : {};

  const cartListItems: Array<JSX.Element> = []

  Object.keys(ticketList).forEach(section => {

    const key = ticketList[section].map(t => t.cart_item_id).join('-')
    const tickets = ticketList[section]

    cartListItems.push(
      <div key={section}>
        {tickets.length > 0 ? (
          <CartListItem key={key} tickets={tickets} />
        ) : (
          null
        )}
      </div>
    );
  })

  useEffect(() => {
    getCart()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <>
      <div className={styles.cartList}>
        {cartListItems.length ? cartListItems : "Shopping cart empty"}
        {nextStepButton}
      </div>
    </>
  )

}